import { render, staticRenderFns } from "./OrdersIndex.vue?vue&type=template&id=697e0241"
import script from "./OrdersIndex.vue?vue&type=script&lang=js"
export * from "./OrdersIndex.vue?vue&type=script&lang=js"
import style0 from "./OrdersIndex.vue?vue&type=style&index=0&id=697e0241&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports